import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAuth } from '../../contexts/Auth';
import { currentProjectState } from '../../recoil/project';
import EnrollmentPrompt from '../security/EnrollmentPrompt';
import { isNewUI } from '../../v2/flag';
import { EnrollmentPrompt as NewEnrollmentPrompt } from '../../v2/components/security/EnrollmentPrompt';
import { MfaRequiredDialog } from '../../v2/components/security/MfaRequiredDialog';
import MfaRequiredModal from '../modals/MfaRequiredModal';

export default function PrivateOutlet() {
    const { isLoggedIn } = useAuth();
    const location = useLocation();
    const currentProject = useRecoilValue(currentProjectState);

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" />;
    }

    // Allow /projects to be shown if user explicitly navigated there (e.g., clicked home icon)
    const showProjectsList = (location.state as any)?.showProjectsList === true || new URLSearchParams(location.search).has("list");

    // Redirect to project if we're on root or projects list and have a valid project
    // But don't redirect if user explicitly wants to see the projects list
    if (
        ["/", "/projects", "/projects/"].includes(location.pathname) &&
        currentProject?.id &&
        !showProjectsList
    ) {
        // The new UI's landing page is the project overview
        return <Navigate to={`/projects/${currentProject.id}/${isNewUI() ? "overview" : "environments"}`} replace />;
    }

    return <>
        {isNewUI() ? <NewEnrollmentPrompt /> : <EnrollmentPrompt />}
        {/* Inside the router and auth context: confirming in place reuses the sign-in challenge */}
        {isNewUI() ? <MfaRequiredDialog /> : <MfaRequiredModal />}
        <Outlet />
    </>;
}